<p-panel
  styleClass="panel-shadow"
  *ngIf="organisationTypeId == 1 || organisationTypeId == 2"
  [style]="{ 'margin-top': '1em' }"
>
  <p-header>
    <div class="panel-header">Pick-up/Drop-off Contacts</div>
  </p-header>

  <div [class.ghost]="!contactPeopleTask">
    <div class="grid-label-value">
      <div class="">Pick-up:</div>
      <div class="value ghost-fill">{{ contactPeopleTask?.pickUpName }}</div>
    </div>
    <div
      class="grid-label-value"
      style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
    >
      <div class="">Drop-off:</div>
      <div class="value ghost-fill">{{ contactPeopleTask?.dropOffName }}</div>
    </div>
  </div>
</p-panel>
